'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

exports['default'] = function (input) {
  return input.replace(/(\d) x (\d)/gim, '$1 × $2').replace(/(\d) - (\d)/gim, '$1 − $2').replace(/(\w) >> (\w)/gim, '$1 ≫ $2').replace(/(\w) << (\w)/gim, '$1 ≪ $2').replace(/(\w) >= (\w)/gim, '$1 ≥ $2').replace(/(\w) <= (\w)/gim, '$1 ≤ $2').replace(/\+-/gim, '±').replace(/-\+/gim, '∓');
};

module.exports = exports['default'];

